import { Box, TextField, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/redux-store/appStore';
import { updateBuilding } from 'src/redux-store/slices/constructionFormSlice';

function EstimatedCostOfWork({ isError = false }) {
  const dispatch = useDispatch();

  // Correctly select the nested estimatedCostOfWork object
  const estimatedCostOfWork = useSelector(
    (state: RootState) =>
      state.constructionFormSlice.Building.EstimateCostOfWork
  );

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    const { name, value } = e.target;
    // Update only the nested property
    if (Number(e.target.value) >= 0)
      dispatch(
        updateBuilding({
          EstimateCostOfWork: {
            ...estimatedCostOfWork,
            [name]: Number(value)
          }
        })
      );
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Typography variant="h5">Estimated Cost of Work</Typography>
      <TextField
        fullWidth
        type="number"
        name="NewBuildingCost"
        label={
          <span>
            New Building<span style={{ color: 'red' }}>*</span>
          </span>
        }
        variant="outlined"
        value={estimatedCostOfWork?.NewBuildingCost || ''}
        onChange={handleChange}
      />

      <TextField
        fullWidth
        type="number"
        name="RehabilitationCost"
        label={
          <span>
            Rehabilitation<span style={{ color: 'red' }}>*</span>
          </span>
        }
        variant="outlined"
        value={estimatedCostOfWork?.RehabilitationCost || ''}
        onChange={handleChange}
      />

      <TextField
        fullWidth
        type="number"
        name="NewVolume"
        label={
          <span>
            New Volume (Cuft)<span style={{ color: 'red' }}>*</span>
          </span>
        }
        variant="outlined"
        value={estimatedCostOfWork?.NewVolume || ''}
        onChange={handleChange}
      />

      <TextField
        fullWidth
        type="number"
        name="NewArea"
        label={
          <span>
            New Area (Sqft)<span style={{ color: 'red' }}>*</span>
          </span>
        }
        variant="outlined"
        value={estimatedCostOfWork?.NewArea || ''}
        onChange={handleChange}
      />

      {isError &&
        (!estimatedCostOfWork?.NewBuildingCost ||
          !estimatedCostOfWork?.RehabilitationCost ||
          !estimatedCostOfWork?.NewVolume ||
          !estimatedCostOfWork?.NewArea) && (
          <Typography color="error">Please fill required field.</Typography>
        )}

      <Typography>
        Total estimated cost : $
        {(
          (estimatedCostOfWork?.NewBuildingCost || 0) +
          (estimatedCostOfWork?.RehabilitationCost || 0)
        ).toLocaleString()}
      </Typography>
    </Box>
  );
}

export default EstimatedCostOfWork;
